import {Injectable, inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {shareReplay} from 'rxjs';
import {CrremReference} from './crrem-calculation';
@Injectable({providedIn:'root'})
export class CrremReferenceService {
    readonly data$ = inject(HttpClient).get<CrremReference>('assets/crrem/reference-v2.05.json')
        .pipe(shareReplay({bufferSize:1,refCount:false}));
}
